import { render, staticRenderFns } from "./AreaSelection.vue?vue&type=template&id=4568c5b8"
import script from "./AreaSelection.vue?vue&type=script&lang=js"
export * from "./AreaSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports